import React from "react";
import "./homepage.css";
import Hero from "/Users/shadsachikonye/shads-dev-1/src/resources/hero.jpg";
import Navigation from "../navigation/navigation";

const HeroSection = ({ name, title, bio }) => {
  return (
    <div className="hero-container">
      <div className="hero-content">
        {/* === Left Side: Text Content === */}
        <div className="hero-text">
          <p className="hero-greeting">👋 Hello, I'm</p>
          <h1 className="hero-name">{name}</h1>
          <h2 className="hero-title">{title}</h2>
          <p className="hero-bio">{bio}</p>
        </div>

        {/* === Right Side: Avatar / Hero Image === */}
        <div className="hero-avatar-area">
          <img src={Hero} alt={`${name}'s Avatar`} className="hero-avatar" />
        </div>
      </div>
    </div>
  );
};

// --- Main Page Component ---
const HomePage = () => {
  // Your personal data
  const personalData = {
    name: "Shad Sachikonye",
    title: "A keen technologist and problem solver!",
    bio: `I specialize in building accessible and responsive web applications. My passion lies in bridging the gap between elegant design and clean code. 
      I enjoy working with the modern JavaScript ecosystem and solving complex problems with simple solutions.Welcome to my corner of the web!`,
    avatar: { Hero },
  };

  return (
    <>
      <Navigation />
      <div className="home-page">
        <HeroSection
          name={personalData.name}
          title={personalData.title}
          bio={personalData.bio}
          avatarUrl={personalData.avatar}
        />
      </div>
    </>
  );
};

export default HomePage;
